export const FORUM_POSTS_RESET_STATE = 'FORUM_POSTS_RESET_STATE';
export const FORUM_POSTS_CURRENT_ITEM = 'FORUM_POSTS_CURRENT_ITEM';

export const FORUM_POSTS_REQUEST_LOADING = 'FORUM_POSTS_REQUEST_LOADING';
export const FORUM_POSTS_REQUEST_SUCCESS = 'FORUM_POSTS_REQUEST_SUCCESS';
export const FORUM_POSTS_REQUEST_FAILED = 'FORUM_POSTS_REQUEST_FAILED';

export const FORUM_POSTS_CURRENT_ACTION = 'FORUM_POSTS_CURRENT_ACTION';
export const FORUM_POSTS_RESET_ACTION = 'FORUM_POSTS_RESET_ACTION';